var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import { Box, Grid, Tooltip } from '@mui/material';
import BaseButton from '../atoms/BaseButton';
var PageSubmitButton = function (_a) {
    var className = _a.className, children = _a.children, disabled = _a.disabled, buttonProps = _a.buttonProps, tooltip = _a.tooltip, tooltipProps = _a.tooltipProps;
    return (React.createElement(Box, { mt: 2 },
        React.createElement(Grid, { container: true, spacing: 2 },
            React.createElement(Grid, { item: true, sm: 4 }),
            React.createElement(Grid, { item: true, xs: 12, sm: 4 }, tooltip ? (React.createElement(Tooltip, __assign({ title: tooltip }, tooltipProps, { enterTouchDelay: 100 }),
                React.createElement("div", null,
                    React.createElement(BaseButton, __assign({ fullWidth: true, disabled: disabled, type: "submit", className: className }, buttonProps), children)))) : (React.createElement(BaseButton, __assign({ fullWidth: true, disabled: disabled, type: "submit", className: className }, buttonProps), children))))));
};
export default PageSubmitButton;
